module.exports = __webpack_public_path__ + "img/coreconsulting_logotype.f7900b1c.png";